"use client";

import { apiClient } from "@/lib/api/api-client";

export const InitialClient = ({ token }: { token?: string | null }) => {
  if (token) {
    apiClient.setToken(token);
  }
  return <></>;
};
InitialClient.displayName = "InitialClient";
